
import { AreaModel, Managers } from './area'
import { DealerModel } from './dealer'
import { AuditStatus } from './status'

export interface SchoolModel {
  area: AreaModel;
  areaId: number;
  createdAt: string;
  id: number;
  managers: Managers;
  name: string;
  status: AuditStatus;
  updatedAt: string;
  dealers: DealerModel[];
}

export const SchoolsOrderBy: { [k: string]: any } = {
  areaId: 'AREA_ID',
  createdAt: 'CREATED_AT',
  'managers.createdBy.id': 'CREATOR_ID',
  'managers.modifiedBy.id': 'MODIFIER_ID',
  name: 'NAME',
  status: 'STATUS',
  updatedAt: 'UPDATED_AT'
}
